import { EntityType } from '@miq/domain';
import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { AssociatedRecord, CurrentDataModel } from './current-data.state';

export class SetAssociatedPropertyAction implements ExecutableAction<CurrentDataModel> {
  static readonly type = '[CurrentData] Set Associated Property';

  constructor(public associatedProperty: Record<string, any>) {}

  private _isProperty = (ap: AssociatedRecord) => ap.type === EntityType.Property;

  execute(params: ExecutableActionParam<CurrentDataModel>): void {
    const { associatedRecords } = params.ctx.getState();

    let nextAssociatedRecords = (associatedRecords ?? []).filter(ap => !this._isProperty(ap));

    if (this.associatedProperty != null) {
      const nextPropertyAssociation = { type: EntityType.Property, data: this.associatedProperty };
      nextAssociatedRecords = nextAssociatedRecords.concat(nextPropertyAssociation);
    }

    params.ctx.patchState({ associatedRecords: nextAssociatedRecords });
  }
}
